import { render, staticRenderFns } from "./ContractHistoryLayer.vue?vue&type=template&id=0831c155&scoped=true&"
import script from "./ContractHistoryLayer.vue?vue&type=script&lang=ts&"
export * from "./ContractHistoryLayer.vue?vue&type=script&lang=ts&"
import style0 from "./ContractHistoryLayer.vue?vue&type=style&index=0&id=0831c155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831c155",
  null
  
)

export default component.exports